function hpVideoGuides(data) {
  return {
    videos: Array.isArray(data.videos) ? data.videos : [],
    categoryList: Array.isArray(data.categories) ? data.categories : [],
    baseUrl: data.baseUrl || window.location.pathname,
    query: '',
    activeCategory: 'all',
    modalOpen: false,
    modalVideoId: null,
    modalTitle: '',
    modalWatchUrl: '',
    triggerEl: null,

    init() {
      const params = new URLSearchParams(window.location.search);
      const slug = params.get('category');
      if (slug) {
        const match = this.categoryList.find((c) => c.slug === slug);
        if (match) this.activeCategory = match.name;
      }
    },

    setCategory(slug) {
      const url = new URL(window.location.href);
      if (slug === 'all') {
        this.activeCategory = 'all';
        url.searchParams.delete('category');
      } else {
        const match = this.categoryList.find((c) => c.slug === slug);
        this.activeCategory = match ? match.name : 'all';
        url.searchParams.set('category', slug);
      }
      history.pushState({}, '', url);
      document.dispatchEvent(
        new CustomEvent('hp:video-guides:filter', { detail: { category: this.activeCategory, slug } })
      );
    },

    get filtered() {
      const q = this.query.trim().toLowerCase();
      return this.videos.filter((video) => {
        const inCategory =
          this.activeCategory === 'all' ||
          (video.categories || []).some((c) => c.trim() === this.activeCategory);
        const inSearch = !q || (video.search || '').includes(q);
        return inCategory && inSearch;
      });
    },

    openVideo(video, evt) {
      this.triggerEl = evt ? evt.currentTarget : null;
      this.modalVideoId = video.id;
      this.modalTitle = video.title;
      this.modalWatchUrl = video.watchUrl;
      this.modalOpen = true;
      document.dispatchEvent(
        new CustomEvent('hp:video-guides:play', {
          detail: { id: video.id, title: video.title, category: (video.categories || [])[0] || '' },
        })
      );
      this.$nextTick(() => {
        if (this.$refs.closeBtn) this.$refs.closeBtn.focus();
      });
    },

    closeModal() {
      this.modalOpen = false;
      this.modalVideoId = null;
      if (this.triggerEl) {
        this.triggerEl.focus();
        this.triggerEl = null;
      }
    },

    trapFocus(evt) {
      const dialog = this.$refs.dialog;
      if (!dialog) return;
      const focusable = dialog.querySelectorAll('button, a[href]');
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (evt.shiftKey && document.activeElement === first) {
        evt.preventDefault();
        last.focus();
      } else if (!evt.shiftKey && document.activeElement === last) {
        evt.preventDefault();
        first.focus();
      }
    },
  };
}
